import { WatchQueryFetchPolicy } from "apollo-client";

export const mainApiConfig = {
    endpoint: '/graphql',
    defaultFetchPolicy: 'cache-and-network' as WatchQueryFetchPolicy,
    //defaultFetchPolicy: 'cache-first' as WatchQueryFetchPolicy,
};